import { render, staticRenderFns } from "./AvLinkTable.vue?vue&type=template&id=004353a0&lang=pug"
import script from "./AvLinkTable.vue?vue&type=script&lang=js"
export * from "./AvLinkTable.vue?vue&type=script&lang=js"
import style0 from "./AvLinkTable.vue?vue&type=style&index=0&id=004353a0&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Block: require('/app/components/generic/Block.vue').default})
